import { render, staticRenderFns } from "./ManagersMultiSelector.vue?vue&type=template&id=2e508739"
import script from "./ManagersMultiSelector.vue?vue&type=script&lang=ts"
export * from "./ManagersMultiSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e508739')) {
      api.createRecord('2e508739', component.options)
    } else {
      api.reload('2e508739', component.options)
    }
    module.hot.accept("./ManagersMultiSelector.vue?vue&type=template&id=2e508739", function () {
      api.rerender('2e508739', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/ManagersMultiSelector.vue"
export default component.exports